import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsSettingsPage } from 'src/modules/settings/components/pages/integrations-settings.page';
import { integrationViewSchema } from 'src/modules/settings/schemas/integrations.schema';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';

export const Route = createFileRoute('/settings/integrations/$integrationId')({
  component: IntegrationsDetailComponent,
  validateSearch: (search) => settingsSearchSchema.parse(search),
  params: {
    parse: (params) => ({
      integrationId: integrationViewSchema.parse(params.integrationId),
    }),
  },
});

function IntegrationsDetailComponent() {
  const { integrationId } = Route.useParams();

  return <IntegrationsSettingsPage activeIntegration={integrationId} />;
}
